import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PopoverMessage from '../popover-tooltip';
import { AlertsMap, DisplayType, ActionDetails } from './alerts-map';
import Modal from '@dbk/ui-modal';
import Button from '@dbk/ui-buttons/src/button/button';
import TermsConditions from '../../screens/auth/terms-conditions';
import DowntimeBanner from '../../components/common/downtime-banner';
import { AVALOQ_ALERT_ID, BENEFICIARY_ADDRESS_ALERT_ID } from '../../constants';

class AlertManager extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeAlert: {},
            currentIndex: 0,
            closePopover: false,
            goToNextButton: false
        }
    }

    getBannerAlert = (alertItems, activeAlert, showAvaloqDownBanner) => {
        // when both Avaloq downtime alert and the beneficiary address alert is present, 
        // prioritize the Avaloq alert over the beneficiary address alert 
        const alertList = Array.isArray(alertItems) ? alertItems : [];
        const avaloqAlert = alertList.find((alertItem) => alertItem?.alertId === AVALOQ_ALERT_ID);
        const isBeneficiaryAddressAlertPresent = alertList.some(
            (alertItem) => alertItem?.alertId === BENEFICIARY_ADDRESS_ALERT_ID
        );

        return showAvaloqDownBanner &&
            avaloqAlert &&
            isBeneficiaryAddressAlertPresent &&
            activeAlert?.alertId === BENEFICIARY_ADDRESS_ALERT_ID
            ? avaloqAlert
            : activeAlert;
    };

    componentDidMount(){
        this.handleState(this.props.alerts.alertItems)
        // this.props.getUserAlerts('FEATURE');
    }

    handleState = (alertItems) => {
        if(alertItems && alertItems.length > 0){
            this.props.setAlertModalOpen(true)
            alertItems.sort((a,b) => a.displayOrder - b.displayOrder)
            this.props.setAlertItems(alertItems);
            this.setState({ activeAlert: alertItems[alertItems.length === 1 && this.props.alerts.isAvaloqDown ? 0 :this.state.currentIndex] })
        }
    }

    componentWillReceiveProps(nextProps){
        if (this.props.alerts.alertItems !== nextProps.alerts.alertItems) {
            this.props.setAlertItems(nextProps.alerts.alertItems)
            this.handleState(nextProps.alerts.alertItems);
        }
        if(this.state.activeAlert?.alertId && nextProps.ui.history.currentLocation.pathname.includes(AlertsMap[this.state.activeAlert.alertId]?.detailsAction.detailsActionComponent) && !this.state.goToNextButton){
            this.handleDontShowAgainLogic()
            this.updateActiveAlert(this.state.currentIndex+1); 
        }
        if (this.props.auth.langCode != nextProps.auth.langCode) {
            this.setState({ closePopover: true })
            this.props.setAlertModalOpen(false)
        }
    }

    handleDontShowAgainLogic = () => {
        const { alerts: { isDontShowAgainCheckbox } } = this.props;
        const { activeAlert } = this.state;
        if(isDontShowAgainCheckbox){
            this.props.setSeenStatus(activeAlert.alertId, ActionDetails.DO_NOT_SHOW);
            this.props.setDontShowAgainCheckbox(false);
        }
    }

    onNextClicked = () => {
        const { currentIndex } = this.state;
        this.handleDontShowAgainLogic()
        this.updateActiveAlert(currentIndex + 1);
    }

    onDetailViewClicked = () => {
        const { currentIndex } = this.state; 
        this.setState({ goToNextButton: true });
        this.handleDontShowAgainLogic()
        this.props.changePage(AlertsMap[this.state.activeAlert.alertId].detailsAction.detailsActionComponent);
        this.updateActiveAlert(currentIndex + 1);
    }

    updateActiveAlert = (currIndex) => {
        const { alerts:  { alertItems }} = this.props;
        if(currIndex < alertItems.length){
            this.setState({
                currentIndex: currIndex,
                activeAlert: alertItems[currIndex],
                goToNextButton: false
            })
        }
        else{
            this.setState({ closePopover: true })
            this.props.setAlertModalOpen(false)
        }
    }

    render(){
        const { activeAlert, currentIndex } = this.state;
        const { i18n: { messages }, auth: { langCode }, alerts: { alertItems, showAvaloqDownBanner } } = this.props;
        const bannerAlert = this.getBannerAlert(alertItems, activeAlert, showAvaloqDownBanner);
        return(
            <div>
                {/* {
                    activeAlert && activeAlert.displayType === "MODAL" && //what is sent by BE for multi-sig
                    <Modal
                        isActive
                        disableOutsideClick
                        className="multisign-notification-modal"
                        // onClose={()=>onCancel()}
                        header={"Multi-signature payment approval"}
                        // header={messages['app.payments.summary.cancelPayment']}
                        content={
                        <div className="multisign-notification-modal__content">
                        <div>
                                <p>Multi-signatory payments.</p>
                                <p> There are 3 payments pending your approval.</p>
                        </div>
                        <div className='button-container' style={{display:'flex', alignItems: 'center', justifyContent:'flex-end'}}>
                                <Button tertiary className="mr-"  >{messages['app.manageContactDetails.btn.cancel']}</Button>
                                <Button   >{'View'}</Button>
                        </div>
                        </div>
                        }
                    />
                } */}
                {
                    activeAlert && activeAlert.displayType === DisplayType.TOOLTIP && AlertsMap[activeAlert.alertId] &&
                    <PopoverMessage
                        targetId={AlertsMap[activeAlert.alertId].targetFeature} 
                        title={activeAlert.title}
                        message1={activeAlert.content}
                        message2="" nextActionLabel={messages['app.alerts.next.label']} 
                        detailsActionLabel={langCode === 'en' ? `${messages['app.alerts.goTo']} ${messages[AlertsMap[activeAlert.alertId].detailsAction.label]}` : `${messages[AlertsMap[activeAlert.alertId].detailsAction.label]} ${messages['app.alerts.goTo']}`} 
                        onDetailsActionClicked={()=> this.onDetailViewClicked()}
                        renderNextButton={currentIndex !== this.props.alerts.alertItems.length-1}
                        renderDontShowAgain={AlertsMap[activeAlert.alertId].doNotShowAgain}
                        onNextActionClicked={() => this.onNextClicked()}
                        onPopoverClose = {() => {this.handleDontShowAgainLogic(); this.setState({closePopover: true}); this.props.setAlertModalOpen(false)}}
                        closePopover = {this.state.closePopover}
                    />
                   
                }
                {
                    bannerAlert?.displayType === DisplayType.BANNER && AlertsMap[bannerAlert.alertId] && showAvaloqDownBanner &&
                    <DowntimeBanner activeAlert={bannerAlert} onNextActionClicked={() => this.onNextClicked()} />
                }
                {
                    activeAlert && activeAlert.displayType === DisplayType.POPUP &&
                    <TermsConditions onNextActionClicked={() => this.onNextClicked()} />
                }
                

            </div>
        );
    }
}

export default createContainer({
    $queries: {
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      },
      auth: {
        langCode: true,
      },
      alerts: {
        alertItems: true,
        isDontShowAgainCheckbox: true,
        isAlertModalOpen: true,
        isAvaloqDown: true,
        showAvaloqDownBanner: true
      },
      ui: {
        history: {
          currentLocation: {
            pathname: true,
          },
        },
    },
      setSeenStatus: { $call: 'alerts.seenStatus' },
      getUserAlerts: { $call: 'alerts.list' },
      setAlertItems: { $set: 'alerts.alertItems'  },
      setDontShowAgainCheckbox : { $set: 'alerts.isDontShowAgainCheckbox' },
      setAlertModalOpen: {$set: 'alerts.isAlertModalOpen'}
    },
})(AlertManager);